import * as React from 'react';

export const withWrapper =
  (Wrapper: React.FC<any>, config = {}) =>
  (Component: any) =>
  (props: any) => {
    return (
      <Wrapper {...props}>
        <Component {...props} {...config} />
      </Wrapper>
    );
  };
